












import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { UserState } from "../store/types";
import MessageList from "./MessageList.vue";
import FeedbackListView from "./FeedbackListView.vue";

@Component({
  components: {
    MessageList,
    FeedbackListView,
  },
})
export default class MessagePanes extends Vue {
  @State("user") user: UserState;
  activeTab = 0;

  toast(message = "") {
    this.$buefy.toast.open({
      duration: 3000,
      message,
      position: "is-bottom",
      type: "is-success",
    });
  }

  get wrapperClasses(): string[] {
    const cls = ['message-panes'];
    switch (this.activeTab) {
      case 1:
        cls.push('mail-templates');
        break;
      default:
        cls.push('feedback-messages');
        break;
    }
    return cls;
  }

}
